import styled, { keyframes } from 'styled-components';
import { AppImage, BodyContainer, Body, Title } from '../../App.styles';
const slideIn = keyframes`
  0%   { bottom: -100%; }
  100% { bottom: 0; }
`;

const bgSlideIn = keyframes`
  0%   {  top: 0%; }
  100% {  top: -30%; }
`;

const textSlideIn = keyframes`
  0%   { opacity: 0; transform: translateY(50px) }
  100% { opacity: 1; transform: translateY(0px) }
`;

export const AboutUsContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const AboutImage = styled(AppImage)`
  animation: ${bgSlideIn} 0.8s cubic-bezier(0, 0, 0.1, 1) 0.8s forwards;
`;

export const AboutTitle = styled(Title)`
  animation: ${textSlideIn} 0.8s cubic-bezier(0, 0, 0.1, 1) 0.8s backwards;
`;

export const AboutBodyContainer = styled(BodyContainer)`
  animation: ${slideIn} 0.5s 0.3s backwards;
`;
export const AboutBody = styled(Body)`
  max-width: ${({ theme }) => theme.breakpoints.sm}px;
  animation: ${textSlideIn} 0.8s cubic-bezier(0, 0, 0.1, 1) 1s backwards;
`;
